import { render } from "./Ave.vue?vue&type=template&id=2c834b80&scoped=true"
import script from "./Ave.vue?vue&type=script&lang=js"
export * from "./Ave.vue?vue&type=script&lang=js"

import "./Ave.vue?vue&type=style&index=0&id=2c834b80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c834b80"

export default script